module.exports = __webpack_public_path__ + "static/img/t2.ece3356.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/technology/t2.jpg
// module id = 4hJU
// module chunks = 0